import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { components } from 'react-select';
export var Input = function Input(props) {
  var passed_describedby = props.selectProps['aria-describedby'];
  var describedby = props['aria-describedby'] + (passed_describedby ? ' ' + passed_describedby : '');
  return /*#__PURE__*/React.createElement(components.Input, _extends({}, props, {
    "aria-describedby": describedby
  }));
};